import React from 'react'
import { PiArrowUpRightBold, PiArrowDownLeftBold } from 'react-icons/pi'
import '../../statement.css'

const OPTIONS = { day: '2-digit', month: 'short', year: 'numeric' };

const Statement = ({ transaction_date, transaction_type, ref_no,deposit_amt,withdrawal_amt,closing_balance,narration }) => {
    return (
        <div className='statement py-3'>
            <div className='grid grid-cols-3 gap-1'>
                <div className="col-span-2">
                    <h5>{new Intl.DateTimeFormat('en-IN', OPTIONS).format(new Date(transaction_date)).toUpperCase()}</h5>
                </div>
                <div className='flex gap-2 justify-end'>
                    <p className='text-light-blue whitespace-nowrap'>&#8377; {transaction_type === 'DEBIT' ? withdrawal_amt : deposit_amt}</p>
                    {transaction_type === 'DEBIT' ? <PiArrowUpRightBold className='icon -mt-1' color='red' /> : <PiArrowDownLeftBold className='icon -mt-1' color='#20f320'  />}
                </div>
            </div>
            <div className='grid grid-cols-3 gap-1 items-center text-gray'>
                <div className="col-span-2">
                    <div className='w-5/6'>
                        <p>
                            <small>
                                {narration}
                            </small>
                        </p>
                        <p className='mt-3 whitespace-nowrap'>
                            <small>Ref Num: {ref_no}</small>
                        </p>
                    </div>
                </div>
                <div className='col text-end whitespace-nowrap'>
                    <small>
                        Balance: &#8377; {closing_balance}
                    </small>
                </div>
            </div>
        </div>
    )
}

export default Statement